import { produce } from 'immer';

import { UpdateImportWizardData } from '../../actions/importWizard/updateImportWizardData';
import { ImportWizardState } from '../../typings/importWizard';

export function updateImportWizardData(state: ImportWizardState, action: UpdateImportWizardData): ImportWizardState {
    return produce(state, draft => {
        const { data } = action;

        draft.importData = {
            campaign: {
                id: String(data.campaignId),
                name: data.campaignName,
                type: data.campaignType
            },
            adsCount: data.adsCount,
            groups:
                data.adGroups &&
                data.adGroups.map(group => ({
                    id: String(group.id),
                    name: group.name
                })),
            ads:
                data.ads &&
                data.ads.map(ad => ({
                    id: String(ad.id),
                    description: ad.description,
                    groupId: String(ad.adGroupId),
                    groupName: ad.adGroupName,
                    images: ad.images
                }))
        };

        if (draft.importFile) {
            draft.importFile = {
                file: draft.importFile.file,
                name: data.uploadedFileInfo.fileName,
                mdsGroupId: String(data.uploadedFileInfo.group)
            };
        }
    });
}
